export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: 'faq-001',
    question: '91免费版真的完全免费吗？有没有隐藏收费项目？',
    answer: '91免费版承诺永久免费使用，所有核心功能均不收取任何费用。我们通过企业合作和技术支持服务获得收入，绝不会向普通用户收费。你可以放心使用全部功能，不存在任何隐藏收费项目或强制付费解锁的情况。',
  },
  {
    id: 'faq-002',
    question: '91免费版支持哪些操作系统？',
    answer: '91免费版目前支持Windows 10/11（64位）和macOS 12及以上版本。我们正在开发Linux版本，预计将在下个季度推出。移动端版本（Android和iOS）也在规划中，敬请期待。',
  },
  {
    id: 'faq-003',
    question: '安装91免费版对电脑配置有什么要求？',
    answer: '91免费版对硬件要求非常友好。最低配置仅需：2GB内存、500MB可用磁盘空间、1GHz处理器即可流畅运行。推荐配置为4GB内存以上，以获得更好的多任务处理体验。即使是老旧电脑也能很好地运行91免费版。',
  },
  {
    id: 'faq-004',
    question: '使用91免费版安全吗？会不会有病毒或捆绑软件？',
    answer: '91免费版通过多家安全厂商的检测认证，确保不含任何病毒、木马或恶意代码。安装过程中不会有任何捆绑软件或强制安装的第三方程序。我们始终将用户安全和隐私放在首位，所有功能都经过严格的安全审查。',
  },
  {
    id: 'faq-005',
    question: '如何获取91免费版的最新版本更新？',
    answer: '打开软件后，系统会自动检测最新版本并提示更新。你也可以在官网下载页面手动下载最新版本安装包。我们建议始终保持软件为最新版本，以获得最佳的使用体验和最新的安全防护。',
  },
  {
    id: 'faq-006',
    question: '91免费版支持哪些文件格式？',
    answer: '91免费版支持超过200种文件格式，涵盖文档（PDF、Word、Excel、PPT）、图片（JPG、PNG、GIF、WebP、SVG）、视频（MP4、MOV、AVI、MKV）、音频（MP3、WAV、FLAC、AAC）、压缩包（ZIP、RAR、7Z）等常见格式。具体支持列表可在帮助文档中查看。',
  },
  {
    id: 'faq-007',
    question: '使用过程中遇到问题怎么办？如何联系技术支持？',
    answer: '你可以通过以下方式获取帮助：1）访问官网的帮助中心，查阅详细的图文教程；2）在社区论坛发帖提问，我们的技术人员和其他热心用户会及时回复；3）通过官网的联系表单提交问题，我们会在24小时内回复。',
  },
];